// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1iCqj2Fiyav-O1ZaidN_-c {\n  padding: var(--space-large) calc(var(--space-large) * 2.5);\n}\n\n._1iCqj2Fiyav-O1ZaidN_-c:nth-child(even) {\n  background-color: var(--body-color);\n  color: var(--brown);\n}\n\n.D182DCfUDFUlLuADbtkXP {\n  display: none;\n}\n\n.HLlZUFrLBeez57POOyI1j {\n  text-align: center;\n  font-size: 3rem;\n  margin-bottom: 30px;\n  text-transform: uppercase;\n  letter-spacing: 0.5rem;\n}\n\n._14NzniIqEoWepOXKZt9_wL:link,\n._14NzniIqEoWepOXKZt9_wL:hover,\n._14NzniIqEoWepOXKZt9_wL:active,\n._14NzniIqEoWepOXKZt9_wL:visited {\n  border: 0;\n}\n\n@media (max-width: 767px) {\n  ._1iCqj2Fiyav-O1ZaidN_-c {\n    padding: var(--space-medium) calc(var(--space-small) * 1.5);\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"section": "_1iCqj2Fiyav-O1ZaidN_-c",
	"hidden": "D182DCfUDFUlLuADbtkXP",
	"title": "HLlZUFrLBeez57POOyI1j",
	"a": "_14NzniIqEoWepOXKZt9_wL"
};
module.exports = exports;
